import { RcClasses } from '../../../../foundation';
export var RcRadioClasses = RcClasses(['root', 'checked', 'disabled'], 'RcRadio');
export var RadioButtonIconClasses = RcClasses(['root'], 'RadioButtonIcon');
